import React from 'react';
import { array, bool, object } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureListing } from '../../util/data';
import { ListingCard } from '../../components/ListingCard/ListingCard';
import Carousel from '../../components/Carousel';
import { getColumnCSS, getResponsiveImageSizes } from '../../components/Carousel/CarouselColumnHelper';

const FeaturedProductsCarousel = ({ 
  featuredListings = [], 
  inProgress = false, 
  error = null,
  currentUser,
  id
}) => {
  // Show loading state
  if (inProgress) {
    return (
      <div className="flex items-center justify-center min-h-[200px] p-8">
        <div className="text-lg text-gray-500 text-center">
          <FormattedMessage id="FeaturedProductsCarousel.loading" />
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[200px] p-8">
        <div className="text-lg text-red-600 text-center">
          <FormattedMessage id="FeaturedProductsCarousel.error" />
        </div>
      </div>
    );
  }

  // Don't render if no featured listings
  if (!featuredListings || featuredListings.length === 0) {
    return null;
  }

  const validListings = featuredListings
    .map(listing => ensureListing(listing))
    .filter(listing => 
      listing && 
      listing.attributes && 
      !listing.attributes.deleted && 
      listing.attributes.state === 'published'
    );

  if (validListings.length === 0) {
    return null;
  }

  // Determine number of columns based on screen size and content
  // This mimics the responsive behavior of the original implementation
  const numColumns = 4; // This corresponds to xl:w-1/4 (4 columns on large screens)

  return (
    <div className="w-full mb-12">

      {/* Carousel */}
      <div className="relative">
        <Carousel
          id={id}
          numColumns={numColumns}
          className={getColumnCSS(numColumns)}
          showArrows={true}
          arrowPrevClassName="bg-white border border-gray-200 text-gray-700 shadow-md transition-all duration-200 ease-in-out hover:bg-gray-50 hover:border-gray-300 hover:-translate-y-0.5 hover:shadow-lg"
          arrowNextClassName="bg-white border border-gray-200 text-gray-700 shadow-md transition-all duration-200 ease-in-out hover:bg-gray-50 hover:border-gray-300 hover:-translate-y-0.5 hover:shadow-lg"
        >
          {validListings.map((listing) => (
            <ListingCard
              key={listing.id.uuid}
              listing={listing}
              showAuthorInfo={true}
              showLikesCount={true}
              currentUser={currentUser}
              renderSizes={getResponsiveImageSizes(numColumns)}
            />
          ))}
        </Carousel>
      </div>
    </div>
  );
};

FeaturedProductsCarousel.propTypes = {
  featuredListings: array,
  inProgress: bool,
  error: object,
  currentUser: object,
};

export default FeaturedProductsCarousel; 